<header class="header">
  @if (breadcrumbs$ | async; as breadcrumbs) {
    @if (breadcrumbsService.isLastSegmentDynamic()) {
      <section class="flex">
        @for (breadcrumb of breadcrumbs; track $index; let isLast = $last) {
          @if (breadcrumb.title | translate; as link) {
            <span class="f-center gap-025">
              @if (isLast) {
                {{ link }}
              } @else if (breadcrumb.isNonNavigable) {
                {{ link }}
                <ui-icon
                  class="header__divider"
                  [name]="'navigate_next'"
                  [size]="iconSize"
                  [color]="color"
                ></ui-icon>
              } @else {
                <a
                  class="header__item-link"
                  [routerLink]="breadcrumb.url"
                >
                  {{ link }}
                </a>
                <ui-icon
                  class="header__divider"
                  [name]="'navigate_next'"
                  [size]="iconSize"
                  [color]="color"
                ></ui-icon>
              }
            </span>
          }
        }
      </section>
    } @else {
      <section class="f-column">
        @for (breadcrumb of breadcrumbs; track $index; let isLast = $last) {
          @if (breadcrumb.title | translate; as link) {
            <span class="f-center gap-025">
              @if (!isLast) {
                @if (breadcrumb.isNonNavigable) {
                  {{ link }}
                } @else {
                  <a
                    class="header__item-link"
                    [routerLink]="breadcrumb.url"
                  >
                    {{ link }}
                  </a>
                }
                <ui-icon
                  class="header__divider"
                  [name]="'navigate_next'"
                  [size]="iconSize"
                  [color]="color"
                ></ui-icon>
              }
            </span>
          }
        }
        @if (breadcrumbs.length) {
          <div class="header__item-link-last">{{ breadcrumbs[breadcrumbs.length - 1].title | translate }}</div>
        }
      </section>
    }
  }
  <img
    ngSrc="assets/logo.svg"
    width="61"
    height="25"
    alt="logo"
    priority
  />
</header>
